import CalcManager from './lib/calc-manager';
import Tooltips from './lib/tooltips';

class App {
    constructor() {
        this.dom = {
            $: window.$,
            $window: $(window),
            $calc: $('.calc')
        };

        if (this.dom.$calc.length) {
            this.init();
        }
    }

    init() {
        this.dom.$calc.each((calcId, calcObj) => new CalcManager(calcObj));
        new Tooltips();
    }
}

document.addEventListener('DOMContentLoaded', () => new App());